import React, { Component } from "react";
import Route from "react-router-dom/es/Route";
import Redirect from "react-router-dom/es/Redirect";
import {setSfaFlow} from "../../actions/userActions";
import store from "../../store";


class PrivateRoute extends Component {

    componentDidMount() {
        const { checkIfUserLoggedIn } = this.props;
        checkIfUserLoggedIn();
    }

    componentDidUpdate(prevProps) {
        const { checkIfUserLoggedIn, location } = this.props;

        if (location.pathname !== prevProps.location.pathname) {
            checkIfUserLoggedIn();
        }
    }

    render() {
        const { component: RouteComponent, authed, ...rest } = this.props;

        // Check fromSfaFlow from sessionStorage only (single source of truth)
        const inSfaFlow = this.props.userReducer?.inSfaFlow;

        return (
            <Route
                {...rest}
                render={(props) => {
                    if (authed === true) {
                        // Clear SFA flow flag when user is fully authenticated
                        if (inSfaFlow) {
                            store.dispatch(setSfaFlow(false));
                        }
                        return <RouteComponent {...props} />;
                    } else {
                        // If user is in the middle of SFA verification, redirect to /sfa instead of /login
                        const redirectPath = inSfaFlow ? '/sfa' : '/login';
                        return <Redirect to={{ pathname: redirectPath, state: { from: props.location } }} />;
                    }
                }}
            />
        );
    }
}

export default PrivateRoute;
